import { Checkbox, FormControl, FormControlLabel, FormGroup, Typography } from '@mui/material';
import React, { FC } from 'react';

interface FilterItemProps {
  label: string;
  value: string;
  count?: number;
}

interface FilterGroupProps {
  refine: (value: string) => void;
  items: FilterItemProps[];
  selected: string[];
}

const FilterGroup: FC<FilterGroupProps> = ({ items, refine, selected }) => {
  return (
    <FormControl sx={{ mx: 3, my: 1 }} component="fieldset" variant="standard">
      <FormGroup>
        {items?.map((item, i) => (
          <FormControlLabel
            key={i}
            control={
              <Checkbox
                checked={selected.includes(item.value?.toString())}
                onChange={() => refine(item.value?.toString())}
                name={item.label}
              />
            }
            label={<Typography sx={{ textTransform: 'capitalize' }}>{item.label}</Typography>}
          />
        ))}
      </FormGroup>
    </FormControl>
  );
};

export default React.memo(FilterGroup);
